// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"7af5d1dc","49":"f79212df","97":"a5bf8d5d","581":"57a8b827","617":"59154743","698":"12ac975e","737":"ff9c9009","750":"2a277c8d","975":"5cef8b7c"}[chunkId] + ".chunk.js";
};